import { FC } from 'react';
import { AlgorithmHeader, AlgorithmHeaderProps } from '../AlgorithmHeader';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './AlgorithmTargetsHeader.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'algorithm-targets-header'
);
addTranslations(translations);

export type AlgorithmTargetsHeaderProps = Omit<
  AlgorithmHeaderProps,
  'id' | 'title'
>;

export const AlgorithmTargetsHeader: FC<AlgorithmTargetsHeaderProps> = (
  props
) => {
  const { t } = useTranslation();
  return (
    <AlgorithmHeader id="algorithm-targets" title={t('title')} {...props} />
  );
};
